export const HERO_PREVIEW_SPEED_OPTIONS = [
  {
    id: "slow",
    label: "Slow preview speed",
    multiplier: 0.65,
  },
  {
    id: "medium",
    label: "Medium preview speed",
    multiplier: 1,
  },
  {
    id: "fast",
    label: "Fast preview speed",
    multiplier: 1.75,
  },
];

export const DEFAULT_HERO_PREVIEW_SPEED_ID = "medium";

export const getHeroPreviewSpeedMultiplier = (speedId) => (
  HERO_PREVIEW_SPEED_OPTIONS.find((option) => option.id === speedId)?.multiplier
  || HERO_PREVIEW_SPEED_OPTIONS.find((option) => option.id === DEFAULT_HERO_PREVIEW_SPEED_ID).multiplier
);

export const scaleHeroPreviewDelayMs = (delayMs, speedMultiplier) => (
  Math.max(400, Math.round(delayMs / speedMultiplier))
);
